import { render, staticRenderFns } from "./GlobalModalsIndex.vue?vue&type=template&id=8c7850e6"
import script from "./GlobalModalsIndex.vue?vue&type=script&lang=js"
export * from "./GlobalModalsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports